import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CircleDollarRegular from './circle-dollar-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CircleDollarRegular {...validProps} />;
}
SvgComponent.iconName = 'circleDollarRegular';

export const CircleDollarRegularIcon = svgIconWrapper(SvgComponent);
